<app-widget [widget-meta]="this.data"
  widgetSubtitle=""
  showHelp="true"
  class="widget-calendar"
  (resizeTo)="onResize($event)"
  (isCollapsed)="onCollapse($event)">
  @if (calendar.fetchCalendar(resourcesCalendar) | async; as cal) {
    <div>
      @if (!data.IsChromeless) {
        <p>View all events on the <a href="https://calendars.kenan-flagler.unc.edu/MasterCalendar.aspx" target="_blank">school-wide calendar</a>. Your filtered calendar shows the next 7 days.</p>
      }
      <!-- Removed header as we are currently going to stick with a static view of the calendar that matches the widget in MyKE -->
      <!--<div *ngIf="this.data.IsChromeless" class="row">
      <div class="col-4">
        <button type="button" class="btn btn-primary btn-borderless" (click)="changeDate('today')">Today</button>
        <button type="button" class="btn btn-primary btn-borderless" (click)="changeDate('prev')"> < </button>
        <button type="button" class="btn btn-primary btn-borderless" (click)="changeDate('next')"> > </button>
        <input name="datePicker" class="dp-input" [(ngModel)]="datePicker" ngbDatepicker #d="ngbDatepicker" (ngModelChange)="changeDate('jump')">
        <button class="btn btn-primary btn-borderless" (click)="d.toggle()" type="button">{{currentTitle}} &#9660;<span class="sr-only">Click to change the date view</span></button>
      </div>
      <div class="col-5">
        <ng-container *ngIf="resourcesCalendar" class="chromeless">
          <button type="button" *ngIf="resourcesCalendar.calendarTeams.events.length > 0" class="btn btn-sm chromeless teams-btn mr-1"
            [ngClass]="resourcesCalendar.customButtons.teams.active ? 'active' : ''"
            (click)="calWidget.closePopovers();resourcesCalendar.calendarEventReload($event)">
            Personal
          </button>
          <button type="button" *ngIf="resourcesCalendar.calendarSchool.events.length > 0" class="btn btn-sm chromeless school-btn mr-1"
            [ngClass]="resourcesCalendar.customButtons.school.active ? 'active' : ''"
            (click)="calWidget.closePopovers();resourcesCalendar.calendarEventReload($event)">
            School
          </button>
          <button type="button" *ngIf="resourcesCalendar.calendarProgram.events.length > 0" class="btn btn-sm chromeless program-btn mr-1"
            [ngClass]="resourcesCalendar.customButtons.program.active ? 'active' : ''"
            (click)="calWidget.closePopovers();resourcesCalendar.calendarEventReload($event)">
            Program
          </button>
          <button type="button" *ngIf="resourcesCalendar.calendarCanvas.events.length > 0" class="btn btn-sm chromeless canvas-btn"
            [ngClass]="resourcesCalendar.customButtons.canvas.active ? 'active' : ''"
            (click)="calWidget.closePopovers();resourcesCalendar.calendarEventReload($event)">
            Canvas
          </button>
        </ng-container>
      </div>
      <div class="col-3 calendar-view-dropdown">
        <i class="fal pr-1" [ngClass]="{'fa-calendar-day':calView == 'singleDay', 'fa-calendar-week': calView == 'workWeek', 'fa-calendar-alt':calView == 'fullWeek'}"></i>
        <select (change)="changeView($event.target.value)">
          <option value="singleDay">Day</option>
          <option value="workWeek">Work week</option>
          <option value="fullWeek" selected>Week</option>
        </select>
      </div>
    </div>-->
    @if ((resourcesCalendar.calendarEventSource.length > 0) && (data.IsChromeless || displayCalendar)) {
      <div class="card-body">
        <kfbs-full-calendar #calendarWidget
          [defaultView]="resourcesCalendar.defaultView"
          [mobileView]="resourcesCalendar.mobileView"
          [defaultHeader]="resourcesCalendar.defaultHeader"
          [views]="resourcesCalendar.views"
          [customButtons]="resourcesCalendar.customButtons"
          [mobileHeader]="resourcesCalendar.mobileHeader"
          [minTime]="resourcesCalendar.minTime"
          [maxTime]="resourcesCalendar.maxTime"
          [mobileWindowSize]="resourcesCalendar.mobileWindowSize"
          [calendarEventSource]="resourcesCalendar.calendarEventSource"
          [widgetSize]="calendarSize"
          [hideDescription]="true"
          [nowIndicator]="data.IsChromeless"
          [allDayText]="'All Day'"
          [useTeamsDetails]="'true'">
        </kfbs-full-calendar>
      </div>
    } @else {
      <div class="card-body">
        You have no events coming up in the next 7 days
      </div>
    }
  </div>
} @else {
  <div class="widget-loading text-center">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
}


</app-widget>
